import * as React from 'react';
import { useTheme } from '../../../../../../theme';
import { useExchangeRouteControls } from '../../lib';
import { ExchangeRefundControls } from '@entities/order';
const ExchangeControlsWrapper = ({ children }) => {
    const { ExchangeControlsWrapper: theme } = useTheme('Features').Exchange;
    const { isShowControls, isEnableContinue, onBack, onContinue } = useExchangeRouteControls();
    return (React.createElement("div", { className: theme.wrapper },
        React.createElement("div", { className: theme.content }, children),
        isShowControls && (React.createElement("div", { className: theme.controls },
            React.createElement(ExchangeRefundControls, { disabledContinue: !isEnableContinue, onBack: onBack, onContinue: onContinue })))));
};
export default ExchangeControlsWrapper;
